<template>
  <div>
    <v-skeleton-loader v-if="loading" class="ml-auto pt-5 pb-4" width="65%" type="heading" />
    <div v-if="!loading" class="d-flex align-items-center justify-center fs-mask">
      <template v-if="price">
        <div class="price dollars line-height-1" :class="{ small }">
          <span class="price cents">$</span>{{ dollarValue.dollars }}
        </div>
        <div class="d-flex price cents line-height-1" :class="{ small }">
          <div class="pt-1">
            {{ dollarValue.cents }}*
          </div>
        </div>
      </template>
      <template v-else>
        —
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    price: { type: Number, default: 0 },
    small: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  computed: {
    dollarValue() {
      const price = Number.parseFloat(this.price)
      if (Number.isNaN(price)) {
        return {
          dollars: '--',
          cents: '--'
        }
      }
      const dollar = (price / 100).toFixed(2)
      return {
        dollars: dollar.split('.')[0],
        cents: dollar.split('.')[1]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .price {
    line-height: 1 !important;
  }

  .price.dollars {
    font-size: 60px;

    &.small {
      font-size: 35px;
    }
  }

  .price.cents {
    font-size: 36px;

    &.small {
      font-size: 16px;
    }
  }
</style>
